import { computed } from "vue";
import { useGetDevices, type Device } from "@/api/devices";
import { useGetLocationGroup } from "@/api/locationGroups";
import { useLocationStore } from "@/stores/location";

import type { Location } from "@/api/locations";

export const useDevices = () => {
  const locationStore = useLocationStore();

  const locationGroupPk = computed(
    () => locationStore.selectedLocationGroup?.id
  );

  const getDevices = useGetDevices({});
  const getLocationGroup = computed(() =>
    locationGroupPk.value ? useGetLocationGroup(locationGroupPk.value) : null
  );

  const selectedLocationGroup = computed(
    () => getLocationGroup.value?.data.value
  );

  const devices = computed(() => getDevices.data.value);
  const activeDevices = computed(
    () => devices.value?.list.filter((device) => device.app_version)
  );

  const devicesAtSelectedGroup = computed(
    () =>
      devices.value?.list.filter(
        (device) =>
          selectedLocationGroup.value?.locations.some(
            ({ id }: Location) => id === device.location.pk
          )
      )
  );

  const isAddonEnabled = (addonType: keyof Device["settings"]) => {
    return Boolean(
      devicesAtSelectedGroup.value?.find((device) => device.settings[addonType])
    );
  };

  return {
    devices,
    activeDevices,
    devicesAtSelectedGroup,
    isAddonEnabled,
  };
};
